import React from 'react'
import {Link} from 'react-router-dom'

export default function SuccessErrorPage(props) {
    let types = {
        success: 
            <>
                <div className="icon-container" style={{backgroundColor: '#25c23fb3'}}>
                    <span className="icon" style={{boxShadow: '0px 3px 3px #25c23fb3'}}>
                        <i className={'fas fa-check'} style={{color: '#25c23fb3'}}></i>
                    </span>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#fff" fillOpacity="1" d="M0,160L60,138.7C120,117,240,75,360,74.7C480,75,600,117,720,149.3C840,181,960,203,1080,186.7C1200,171,1320,117,1380,90.7L1440,64L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"></path></svg>
                <div className="message-container">
                    <div className="message">
                        <div>
                            <h3>Success!</h3>
                            <h4>{props.message}</h4>
                        </div>
                    </div>
                </div>
            </>,
        error:
            <>
                <div className="icon-container" style={{backgroundColor: '#f33838f0'}}>
                    <span className="icon" style={{boxShadow: '0px 3px 3px #dd3030'}}>
                        <i className={'fas fa-exclamation'} style={{color: 'red'}}></i>
                    </span>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#fff" fillOpacity="1" d="M0,160L60,138.7C120,117,240,75,360,74.7C480,75,600,117,720,149.3C840,181,960,203,1080,186.7C1200,171,1320,117,1380,90.7L1440,64L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"></path></svg>
                <div className="message-container">
                    <div className="message">
                        <div>
                            <h3>Something went wrong!</h3>
                            <br/>
                            <h4 className='red-text'>The information you entered might be invalid:</h4>
                            <h4 className='red-text'>{props.message}</h4>
                            <br/>
                        </div>
                    </div>
                </div>
            </>,
        generic:
            <>
                <div className="icon-container" style={{backgroundColor: '#faf7a9'}}>
                    <span className="icon" style={{boxShadow: '0px 3px 3px #b6b476'}}>
                        <i className={'fas fa-exclamation-triangle'} style={{color: '#9b9966'}}></i>
                    </span>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#fff" fillOpacity="1" d="M0,160L60,138.7C120,117,240,75,360,74.7C480,75,600,117,720,149.3C840,181,960,203,1080,186.7C1200,171,1320,117,1380,90.7L1440,64L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"></path></svg>
                <div className="message-container">
                    <div className="message">
                        <h3 style={{color: '#7c7b52'}}>Please be advice:</h3>
                        <div>
                            <h4 className='black-text'>{props.message}</h4>
                        </div>
                    </div>
                </div>
            </>

    }
    return (
        <main className="successError">
            {types[props.type]}

            {
                props.ctas ? 
                <div className="ctas">
                    {props.ctas.map((item, index) => {
                        return (
                            item.customFunction ? <button onClick={item.customFunction}>{item.message}</button> : 
                            <Link to={`/cp/${item.location}`} key={index}>
                                <button>{item.message}</button>
                            </Link>
                        )
                    })}
                </div> : null
            }
        </main>
    )
}
